<template>
	<div class="info-cls">
		<div class="divv">
			<div class="describe-cls">
				当前位置：
				<span v-if="qaDetail.parentNode" v-for="(v, i) in qaDetail.parentNode" :key="i">
					{{v.name}}
					<i v-show="i+1 !== qaDetail.parentNode.length"> / </i>
				</span>
			</div>
			<div class="html-cls" v-html="qaDetail.a"></div>
			<div class="help-cls">
				<span>有帮助？ <svg-icon :class="{'agree': qaDetail.helpType === 'agree'}" @click.stop="handleHelp(qaDetail, true, 'detail')" style="margin-right: 8px" icon-class="Agree" /> <svg-icon :class="{'no-agree': qaDetail.helpType === 'no-agree'}" @click.stop="handleHelp(qaDetail, index, false, 'detail')" icon-class="NoAgree" /></span>
				<span>有帮助：{{qaDetail.help}}</span>
				<span>查看量：{{qaDetail.click}}</span>
				<span>最近修改时间：{{qaDetail.lastUpdateTime | formatDate}}</span>
			</div>
			<div class="associated-cls" v-if="sourceList[sjs]">
				<div class="title-cls">相关知识</div>
				<div class="btns-cls">
					<el-button @click.stop="handleBigScreenInfo(sourceList[sjs])" type="primary" size="mini" plain round>{{sourceList[sjs]['q']}}</el-button>
					<!-- <el-button v-if="sourceList.length > 1" @click.stop="handleBigScreenInfo(sourceList[sjs === 6 ? sjs - 1 : sjs + 1])" type="primary" size="mini" plain round>{{sourceList[sjs === 6 ? sjs - 1 : sjs + 1]['q']}}</el-button> -->
				</div>
			</div>
			<!-- <div class="tabs-cls">
				<el-tabs v-model="activeName">
					<el-tab-pane label="评论" name="first"><el-empty description="暂无数据"></el-empty></el-tab-pane>
					<el-tab-pane label="附件" name="second"><el-empty description="暂无数据"></el-empty></el-tab-pane>
					<el-tab-pane label="历史记录" name="third"><el-empty description="暂无数据"></el-empty></el-tab-pane>
				</el-tabs>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'KnowledgeInfo',
	props: ['qaDetail', 'sourceList', 'sjs'],
	data() {
		return {
			activeName: 'first'
		}
	},
	methods: {
		handleBigScreenInfo(item) {
			this.$emit('emitScreenInfo', item);
		},
		handleHelp(item, type) {
			const self = this;
			if(item.isHelp) return;
			item['isHelp'] = true;
			item['helpType'] = type ? 'agree' : 'no-agree';
			Vue.set(self.qaDetail, item);
			self.$api.apiPostKnowledgeSetHelp({
				projectId: self.qaDetail.projectId,
				id: item.id,
				type: type ? 1 : 2
			});
		},
	}
}
</script>

<style lang="scss" scoped>
.info-cls {
	width: 100%;
	padding: 20px;
	box-sizing: border-box;

	

	& > .divv {
		padding: 0 20px;
		box-sizing: border-box;
		& > .html-cls {
			margin-top: 30px;
			width: 100%;
			height: auto;
			padding: 0 20px 30px;
			box-sizing: border-box;
			font-size: 14px;
			font-weight: 400;
			color: #6C7E91;
			line-height: 22px;
		}

		& > .help-cls {
			border-bottom: 1px solid #efefef;
			width: 100%;
			height: 24px;
			font-size: 12px;
			font-weight: 400;
			color: #A6AAB8;
			line-height: 24px;
			text-align: right;
			padding-bottom: 35px;
			box-sizing: border-box;
			margin-bottom: 10px;

			& > span:nth-of-type(1) {
				float: left;
				margin: 0;
			}

			& > span {
				margin-left: 15px;
			}
			
			& .svg-icon {
				cursor: pointer;

				&.agree {
					color: #f29521;
				}

				&.no-agree {
					color: #ff504d;
				}
			}
		}

		& > .associated-cls {
			width: 100%;
			margin-bottom: 20px;

			& > .title-cls {
				font-size: 12px;
				font-weight: 400;
				color: #337EFF;
				font-weight: 500;
				line-height: 24px;
				margin-bottom: 5px;
			}

			& > .btns-cls {
				width: 100%;
				height: 24px;
				margin-bottom: 12px;

				& .el-button {
					background: #fff;
					height: 24px;
					line-height: 24px;
					padding: 0 15px;
					box-sizing: border-box;
					font-size: 12px;
					color: #337EFF;
				}
			}
		}

		& > .tabs-cls {
			width: 100%;
			padding-bottom: 50px;
			box-sizing: border-box;
		}

		& > .describe-cls {
			font-size: 12px;
			font-weight: 400;
			color: #6C7E91;
			line-height: 24px;
			box-sizing: border-box;
			font-weight: 900;

			& > p {
				line-height: 20px;
				margin-bottom: 3px;

				& > span {
					margin-right: 20px;

					&:nth-of-type(3) {
						float: right;
						margin: 0;
					}
				}
			}
		}
	}
}
</style>